import { ComponentRef, ViewContainerRef } from "@angular/core";
import { SetMultiFactorAuthComponent } from "./set-multi-factor-auth.component";


class SetMultiFactorAuthSession implements com.ts.mobile.sdk.UIFormSession{
    clientContext: object;
    actionContext: object;
    formId: string;
    payload: object;

    submitHandler: any;
    submitBlock: (payload: object) => void;
    viewContainerRef: ViewContainerRef;
    setMultiFactorAuthComponentRef: ComponentRef<SetMultiFactorAuthComponent>;

    constructor(formId: string, payload: object) {

        this.formId = formId;
        this.payload = payload;
    }

    startSession(clientContext: object | null, actionContext: com.ts.mobile.sdk.PolicyAction | null): void {

        this.clientContext = clientContext;
        this.actionContext = actionContext;
        this.viewContainerRef = (clientContext as any).viewContainerRef;
      }

      endSession(): void {

      }

      promiseFormInput(): Promise<com.ts.mobile.sdk.FormInput> {
        this.viewContainerRef.clear();
        this.setMultiFactorAuthComponentRef = this.viewContainerRef.createComponent(SetMultiFactorAuthComponent);

        this.setMultiFactorAuthComponentRef.instance.emailAddress = this.clientContext['email_mfa'];
        this.setMultiFactorAuthComponentRef.instance.recoveryNumber = this.clientContext['mobile_mfa'];
        this.setMultiFactorAuthComponentRef.instance.skip = this.clientContext['skip_mfa'];

        this.setMultiFactorAuthComponentRef.instance.onMFAEnableSubmit = this.onMFASubmit.bind(this);
        this.setMultiFactorAuthComponentRef.instance.onMFASkipSubmit = this.onMFASkipSubmit.bind(this);

        const journeyPayload = this.payload as JourneyPayload;

        return new Promise((resolve, reject) => {
          this.submitBlock = (payload: object) => {
            try {
              resolve(com.ts.mobile.sdk.FormInput.createFormInputSubmissionRequest(Object.assign(payload)));

              this.submitBlock = null;
            } catch (e) {

              console.error(e);
            }
          };
        });
      }

      onContinue(payload: object): void {

      }

      onError(payload: object): void {

      }

      private onMFASubmit(payload: object) {
        const data = payload;
        this.submitBlock(data);
      }

      private onMFASkipSubmit(payload: object) {
        const data = payload;
        this.submitBlock(data);
      }
}

interface JourneyPayload {
    actions: ActionsInPayload[];
    stat: string;
    code: string;
    flow: string;
  }

interface ActionsInPayload {
    [key: string]: any;
  }

export default SetMultiFactorAuthSession;
